import type { ICancellationToken } from '@cian/http-api';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IGetOffersByPinResponse200,
  type IGetOffersByPinResponse400,
  type TGetOffersByPinRequest,
  type TGetOffersByPinResponse_1,
  createGetOffersByPinModel,
  fetchGetOffersByPin,
} from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
  parameters: TGetOffersByPinRequest;
};

export function fetchGetOffersByPinService(params: FetchServiceParams): Promise<TGetOffersByPinResponse_1> {
  const {
    applicationContext: { httpApi, logger },
    parameters,
    cancellationToken,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createGetOffersByPinModel(parameters),
    '@/shared/store/serverSide/search-offers/v1/get-offers-by-pin/internal/fetchService.ts',
    logger,
  );

  return fetchGetOffersByPin<IGetOffersByPinResponse200, IGetOffersByPinResponse400>({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
